import { Box, Typography, makeStyles } from '@material-ui/core';

export const useStateDimensionStyles = makeStyles(theme => ({
  dimension: { display: 'grid', gap: theme.spacing(0.5) },
  reason: { color: theme.palette.text.secondary },
}));

export function StateDimension(props: {
  label: string;
  value: string;
  detail?: string | null;
}) {
  const classes = useStateDimensionStyles();
  return (
    <Box className={classes.dimension}>
      <Typography variant="overline" component="h3">
        {props.label}
      </Typography>
      <Typography variant="body1">{props.value}</Typography>
      {props.detail ? (
        <Typography variant="caption" className={classes.reason}>
          {props.detail}
        </Typography>
      ) : null}
    </Box>
  );
}
